import { render, staticRenderFns } from "./_ticket.vue?vue&type=template&id=fc70f9d0&scoped=true&"
import script from "./_ticket.vue?vue&type=script&lang=js&"
export * from "./_ticket.vue?vue&type=script&lang=js&"
import style0 from "./_ticket.vue?vue&type=style&index=0&id=fc70f9d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc70f9d0",
  null
  
)

export default component.exports